import { render } from "./VabeneIngredientBaseListPage.vue?vue&type=template&id=62383dde&ts=true"
import script from "./VabeneIngredientBaseListPage.vue?vue&type=script&lang=ts"
export * from "./VabeneIngredientBaseListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__